import React from "react"; 


 
export const createGrpStyle = {
    control: (provided, state) =>({
      ...provided,
      borderColor:'#ced0d4a6',
      borderWidth: '1px'
    }),
}


